initCalculator = () => {

  let inputHeight = document.getElementById("calc-height");
  let inputWidth = document.getElementById("calc-width");
  let add15 = document.getElementById("add15");
  let calcPrice = document.getElementById("calc-price");
  let calcAdd = document.querySelector(".product-footage .trigger-calc-add");

  if (!inputWidth || !inputHeight) return;

  inputHeight.addEventListener("keyup", inputChange);
  inputWidth.addEventListener("keyup", inputChange);
  add15.addEventListener("change", inputChange);

  let selections = document.getElementsByClassName("calc-selection");

  Array.prototype.slice.call(selections).forEach((select) => {

    select.addEventListener("click", (event) => {

      if (inputWidth.value === "" || inputHeight.value === "") return;

      if (!hasClass(select, "is-selected")) {

        select.classList.remove("disabled");
        select.classList.add("is-selected");

        Array.prototype.slice.call(selections).forEach((el) => {

          if (el !== select) {
            el.classList.add("disabled");
            el.classList.remove("is-selected");
          }
        });

        /* --- Select size --- */

        const variantSelects = document.querySelector("variant-selects");

        const size = select.getAttribute("data-selector").replaceAll("-", " ");
        document.querySelector("select[name='options[Size]']").value = size;
        document.querySelector("input[name='quantity']").value = select.getAttribute("data-count");

        //force update of Variant data
        variantSelects.onVariantChange();

        const price = variantSelects.currentVariant?.price;
        if (price) {
          let curPrice = price / 100;

          // /* --- Update cart button --- */
          calcPrice.textContent = "$" + (curPrice * parseInt(select.getAttribute("data-count"))).toLocaleString("en-US", { minimumFractionDigits: 0 });
          calcPrice.setAttribute("data-usd", curPrice * parseInt(select.getAttribute("data-count")));

          calcAdd.classList.remove("disabled");
          calcAdd.setAttribute("data-quantity", select.getAttribute("data-count"));
        } else {
          calcAdd.classList.add("disabled");
        }

        // Zonos.swapPrice();
      }
    });
  });

  /* --- setup add to cart --- */
  let lock = false;

  calcAdd.addEventListener("click", () => {

    if (lock === false) {

      lock = true;

      const closeTriggers = document.querySelectorAll(".js-product-footage-close");

      closeTriggers.forEach(trigger => {
        trigger.click();
      });

      document.querySelector(".js-go-cart-add-to-cart.product-form__submit").click();


      setTimeout(() => {
        lock = false;
      }, 1000);
    }

  });
};

const inputChange = (target) => {

  let inputHeight = document.getElementById("calc-height");
  let inputWidth = document.getElementById("calc-width");
  let totalElem = document.getElementById("calc-total");
  let sqFt = inputWidth.value * inputHeight.value;
  let calcPrice = document.getElementById("calc-price");
  let calcAdd = document.querySelector(".product-footage .trigger-calc-add");
  let selected;

  /* --- check if height and width are included, and check for NaN --- */
  if (inputWidth.value !== "" && inputHeight.value !== "" && sqFt == sqFt) {

    let options = document.getElementsByClassName("product-footage__panels-option");

    totalElem.textContent = sqFt + " sq ft.";

    Array.prototype.slice.call(options).forEach((opt) => {

      let optWidth = opt.getAttribute("data-width");
      let optHeight = opt.getAttribute("data-height");
      let optDiviser = (opt.getAttribute("data-diviser")) ? parseInt(opt.getAttribute("data-diviser")) : 1;
      let optPack = (opt.getAttribute("data-pack-size")) ? parseInt(opt.getAttribute("data-pack-size")) : 1;
      let verbage = (opt.getAttribute("data-verbage")) ? opt.getAttribute("data-verbage") : "panels";

      let widthCount = Math.ceil(inputWidth.value / Math.floor(optWidth / optDiviser));
      let heightCount = Math.ceil(inputHeight.value / Math.floor(optHeight / optDiviser));

      let total = Math.ceil((widthCount * heightCount) / optPack);
      let add15 = document.getElementById("add15");

      if (add15.checked) {
        total = Math.ceil(total * 1.15);
      }

      opt.setAttribute("data-count", total);

      let updateElem = opt.querySelector(".calc-update");

      updateElem.textContent = total + " " + verbage;

      if (hasClass(opt, "is-selected")) {
        selected = opt;
      }
    });

    /* --- Update pricing and stuff if selected --- */
    if (selected) {
      const variantSelects = document.querySelector("variant-selects");
      let curPrice = variantSelects.currentVariant.price / 100;

      // let curPrice = document.querySelector(".price-item.price-item--regular");
      // curPrice = parseInt(curPrice.getAttribute("data-usd").trim().substring(1));

      /* --- Update cart button --- */
      calcPrice.textContent = "$" + (curPrice * parseInt(selected.getAttribute("data-count"))).toLocaleString("en-US", { minimumFractionDigits: 0 });
      calcPrice.setAttribute("data-usd", curPrice * parseInt(selected.getAttribute("data-count")));

      calcAdd.classList.remove("disabled");
      calcAdd.setAttribute("data-quantity", selected.getAttribute("data-count"));
      document.querySelector("input[name='quantity']").value = selected.getAttribute("data-count");
      // Zonos.swapPrice();
    }

  } else {

    totalElem.textContent = "0 sq ft.";
  }
};